import { useColor } from '@/hooks/useColor';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

const NextPageFetchingIndicator = () => {
  const colors = useColor();
  return (
    <View style={styles.container}>
      <ActivityIndicator color={colors.primary} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 25
  }
});

export default NextPageFetchingIndicator;
